import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Minus = createSvgIcon(React.createElement("polygon", { points: "6,11 6,13 18,13 18,11 " }), 'Minus');
export default Minus;
